import React from 'react';
import { FadeIn } from './ui/FadeIn';
const items = [{
  emoji: '⚡',
  title: 'El diagnóstico de habilidades',
  desc: 'Responde 10 preguntas simples y descubre exactamente cuáles de tus habilidades actuales pueden generar dinero esta semana. Sin cursos. Sin certificados. Con lo que ya sabes hacer.'
}, {
  emoji: '🗺️',
  title: 'El mapa de 7 oportunidades',
  desc: 'Las 7 formas más rápidas de generar $20 a $100 en menos de 48 horas usando solo tu celular o laptop. Cada método con pasos numerados y tiempo estimado de implementación.'
}, {
  emoji: '💬',
  title: 'Scripts listos para copiar',
  desc: 'Mensajes exactos que puedes enviar hoy mismo por WhatsApp, Instagram o correo para conseguir tu primer cliente o tu primera venta. Sin saber vender. Sin experiencia.'
}, {
  emoji: '⏰',
  title: 'El plan hora a hora',
  desc: 'Un cronograma de 48 horas con instrucciones específicas: qué hacer en la hora 1, qué hacer en la hora 6, qué hacer en la hora 24. Sin adivinar el siguiente paso.'
}, {
  emoji: '📊',
  title: 'El sistema de seguimiento',
  desc: 'La hoja de control simple para saber exactamente cuánto llevas generado, qué está funcionando y qué ajustar para seguir creciendo después de las 48 horas.'
}];
export const WhatYouGet = () => {
  return <section className="py-20 md:py-24 bg-dark" data-id="element-249">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-250">
        <FadeIn data-id="element-251">
          <div className="text-center mb-14" data-id="element-252">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-253">
              Esto es lo que obtienes hoy
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight" data-id="element-254">
              Todo lo que necesitas para activar ingresos en las próximas 48
              horas:
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-255">
          {items.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-256">
              <div className="bg-[#111111] border border-white/10 rounded-xl p-6 md:p-7 flex items-start gap-5 hover:border-[#ADFF2F]/40 transition-colors" data-id="element-257">
                <div className="shrink-0 w-12 h-12 rounded-full bg-[#ADFF2F]/10 border border-[#ADFF2F]/30 flex items-center justify-center text-2xl" data-id="element-258">
                  {item.emoji}
                </div>
                <div className="flex-1" data-id="element-259">
                  <h3 className="text-xl md:text-2xl text-white font-bold mb-2 font-sans" data-id="element-260">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-base md:text-lg leading-relaxed font-sans m-0" data-id="element-261">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};